export const ACTIVATE_ATTIRE_CATEGORIES = ['NTQ=', 'Njk=', 'OTk=', 'MTEx'];
